'use client'

import type { Extra } from '@cocoonspace/sdk-js/types/extra'

import { AppWrapper } from '~/components/app-wrapper'
import { SiteFooter } from '~/components/site-footer'
import { ExtrasPage } from '~/domains/extras/components/pages/extras-page'

export const Page = ({ extras }: { extras: Extra[] }) => (
	<AppWrapper>
		<ExtrasPage extras={extras} />
		<SiteFooter />
	</AppWrapper>
)
